import React from 'react';
import { NavLink, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import s from './NavBar.module.css';
import { HOME, SAVING_ACCOUNTS } from '../../router/Constants';
import {
    ABOUT_US, CARDS, COMMERCIAL_BANKING, CONTACT,
    DIGITAL_ASSETS_BANKING, FAQ, PRIVATE_BANKING, TRADE_FINANCE
} from "../../router/Constants";
import './index.css';

const publicRoutes = [
    { path: ABOUT_US, titleKey: "aboutUs"},
    { path: SAVING_ACCOUNTS, titleKey: "savingAccounts"},
    { path: PRIVATE_BANKING, titleKey: "privateBanking" },
    { path: COMMERCIAL_BANKING, titleKey: "commercialBanking" },
    { path: CARDS, titleKey: "cards"},
    { path: DIGITAL_ASSETS_BANKING, titleKey: "digitalAssetsBanking" },
    { path: TRADE_FINANCE, titleKey: "tradeFinance"},
    { path: FAQ, titleKey: "faq"},
    { path: CONTACT, titleKey: "contact"},
];

const NavBarWithRoutes = () => {
    const { t, i18n } = useTranslation();

    return (
        <>
            <div className={s.wrapper} dir={i18n.language === 'fas' ? 'rtl' : 'ltr'}>
                <NavLink className={s.link} to={HOME}>{t('home')}</NavLink>
                {publicRoutes.map((item) => (
                    <NavLink key={item.path} to={item.path} className={s.link}>{t(`routes.${item.titleKey}`)}</NavLink>
                ))}
            </div>
            <Routes>
                {publicRoutes.map((route) => (
                    <Route key={route.path} path={route.path}/>
                ))}
            </Routes>
        </>
    );
};

export default NavBarWithRoutes;
